import DeleteParticipant from './DeleteParticipant';

export default DeleteParticipant;
